import { useEffect, useState } from 'react';
import Select from 'react-select';

import { appelRecupInfoGet } from '../../fonctionsDiv.js'

import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import MarqueRequis from '../../Components/Form/MarqueRequis.jsx';
import {MessageErreurApi} from '../../Components/Messages.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";

const Etape4Lieu = ({ formData, setFormData, onPrevious, onNext }) => {
  // pour react-select
  const [dataVillePourSelect, SetDataVillePourSelect] = useState(); // ici la cible ne contiendra pas les données brutes de l'api mais un tab d'objet ,ex : 0: Object { value: xx, label: "xxx } 
  const [tabObjVillePreselectionnee, SetTabObjVillePreselectionnee] = useState([]); // pour que le reactselect affiche ce qui a déjà été selectionné

  const [messageProbleme, setMessageProbleme] = useState();
  const [dataLoaded, setDataLoaded] = useState(true);

  function checkAllRight() {
    var pb = 0;


    if (formData.LieuDenomination === '' || formData.LieuAdresse1 === '' ) {
      alert("Veuillez remplir tous les champs obligatoires.");  
      pb = 1;
    }
    
    if (pb == 0 && formData.LieuVilleId == 0) {
      alert("Veuillez choisir une ville.");  
      pb = 1;
    }
    else if (formData.LieuMail != formData.LieuMailConfirm) { // formData.ResponsableMail != emailConfimationVal
      alert("Les e-mails saisis ne correspondent pas.");  
      pb = 1;
    }
    else if (formData.LieuMail !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.LieuMail)) {
      alert("Veuillez entrer une adresse email valide.");
      pb = 1;
    }

    if(pb == 0) onNext();
  }
 
  // Pour test, on renseigne les champs obligatoires
  function renseigneToutPourTest() {    
    setFormData({      ...formData,
      LieuDenomination: "Lieu nom",
      LieuAdresse1: "lieu adresse",
      LieuAdresse2: "complément adresse",
      LieuMail: "mail.lieu@free.fr",
      LieuMailConfirm: "mail.lieu@free.fr",
      LieuTelFixe: "07 85 89 98 78",
      LieuTelPortable: "06 85 89 98 79",
      LieuSiteWeb: "https://siteweb.lieu.fr",
    });
  }
    //const [villeSelectionnee, setVilleSelectionnee] = useState(); // sera vide si l'utilisateur n'a pas fait de modif, tableau d'objet
    // const [modifVilleSelectionnee, setModifVilleSelectionnee] = useState(false);
    function handleChangeVilleSelect (selectedOptions)  {
      if(global.config.modeDebugApp == 1) console.log("ville selectionnée : ", selectedOptions)
      //setVilleSelectionnee(selectedOptions);
      setFormData({ ...formData, LieuVilleId: selectedOptions.value, LieuVilleLib: selectedOptions.label }); // on renseigne le champ de la ville avec l'id de la ville sélectionnée

      var preselectionnes = [];
      let ligne = {'value': selectedOptions.value, 'label':  selectedOptions.label};
      preselectionnes.push(ligne);
      SetTabObjVillePreselectionnee(preselectionnes);
    }

    async function chargementsConsecutifs() {
      var pb = false;
      setDataLoaded(false);

      // pour select ville début
      var ret = await appelRecupInfoGet("", "villes", setMessageProbleme);
      if(ret == null) pb = true;
      //else SetDataVille(ret);
      
      if(pb == false ) {
        var donneesPourSelect = [];
        ret.forEach((el) => {
            //console.log("el.id : ", el.id, 'lib : , ', el.lib);
            let ligne = {'value': el.id, 'label':  el.lib};
            donneesPourSelect.push(ligne);                                     
        });
        SetDataVillePourSelect(donneesPourSelect); // attention ici la cible ne contiendra pas les données brutes de l'api mais un tab d'objet
      }
      // pour select ville fin

      if(pb == true ) setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
      setDataLoaded(true);
    }

  useEffect(() => {  
      setMessageProbleme(null);
      chargementsConsecutifs();
  }, []);

  return (
    <div>
      {global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>Etape4Lieu</div>}
      <h3>Déclaration du lieu où se déroulent les formations (obligatoirement en PACA)</h3>

      <LoadingSpinner dataLoaded={dataLoaded}/>
      <MessageErreurApi message={messageProbleme} />

      {dataLoaded && 
      <>
        <ButtonDeBase typeSubmit={true} onClick={renseigneToutPourTest} lib="test : tout renseigner" className2="myside2" className=""/><br />
        <p style={{paddingTop: "20px", fontWeight: "bold"}}>Merci de renseigner les informations suivantes :</p>
        <input
          type="text"
          placeholder="Dénomination (nom du lieu ou de la structure)"
          value={formData.LieuDenomination}
          onChange={(e) => setFormData({ ...formData, LieuDenomination: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "300px", margin: 10, display: "inline"}}
        /><MarqueRequis />
        <br />

        <input
          type="text"
          placeholder="Adresse"
          value={formData.LieuAdresse1}
          onChange={(e) => setFormData({ ...formData, LieuAdresse1: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "300px", margin: 10, display: "inline"}}
        /><MarqueRequis />
        <br />
        <input
          type="text"
          placeholder="Complément d'adresse"
          value={formData.LieuAdresse2}
          onChange={(e) => setFormData({ ...formData, LieuAdresse2: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "300px", margin: 10, display: "inline"}}
        />
        <br />

        {dataVillePourSelect && dataVillePourSelect.length > 0 &&        
          <Select
            placeholder="Ville 🏛️ : vous pouvez commencer à saisir les 1ères lettres ou utiliser la liste déroulante 👉" 
            className="react-select-container"
            onChange={handleChangeVilleSelect}
            closeMenuOnSelect={true}   
            defaultValue={tabObjVillePreselectionnee}
            options={dataVillePourSelect} />
        }
        
        <input
          type="email"
          placeholder="Email"
          value={formData.LieuMail}
          onChange={(e) => setFormData({ ...formData, LieuMail: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "300px", margin: 10, display: "inline"}}
        />     


        <input
          type="email"
          placeholder="Email (confirmation)"
          value={formData.LieuMailConfirm}
          onChange={(e) => setFormData({ ...formData, LieuMailConfirm: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "300px", margin: 10, display: "inline"}}
        />
        <br />
        
        <input
          type="text"
          placeholder="Téléphone fixe"
          value={formData.LieuTelFixe}
          onChange={(e) => setFormData({ ...formData, LieuTelFixe: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "200px", margin: 10, display: "inline"}}
        />
        <input
          type="text"
          placeholder="Téléphone portable"
          value={formData.LieuTelPortable}
          onChange={(e) => setFormData({ ...formData, LieuTelPortable: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "200px", margin: 10, display: "inline"}}
        />
        <br />

        <input
          type="text"
          placeholder="Adresse de site web"
          value={formData.LieuSiteWeb}
          onChange={(e) => setFormData({ ...formData, LieuSiteWeb: e.target.value })}
          className="form-control form-input-lg-short"
          style={{ width: "625px", margin: 10, display: "inline"}}
        />

        <br />
        <div><span className="text-obligatoire">Les champs signalés d'un astérisque rouge * sont obligatoires.</span></div>
        <div className="partie-bouton-droite">
          <ButtonDeBase typeSubmit={false} onClick={onPrevious} lib="Étape précédente" className2="myside2" className="" />
          &nbsp;&nbsp;&nbsp;                
          <ButtonDeBase typeSubmit={true}  onClick={checkAllRight} lib="Terminer" />
        </div>
      </>}
    </div>
  );
};

export default Etape4Lieu;
